import { Location } from '@angular/common';
import { Component, OnInit, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExpedientesService } from '../../services/expedientes.service';

@Component({
  selector: 'app-actuacion-adjunto',
  templateUrl: './actuacion-adjunto.component.html',
  styleUrls: ['./actuacion-adjunto.component.css']
})
export class ActuacionAdjuntoComponent implements OnInit {
  @ViewChild("subirArchivo") archivoSubido: ElementRef;
  @ViewChild("mensaje") mensaje: ElementRef;
  codigo;
  adjunto={};
  archivo;

  constructor(private location:Location, private router:Router,
    private activatedRoute:ActivatedRoute, private expedientesService:ExpedientesService,
    private renderer:Renderer2) { 
    
    
    if(!this.expedientesService.expedienteActivo || !this.expedientesService.actuacionActiva){
      this.location.back();
    }

    this.activatedRoute.params.subscribe(params=>{
      this.codigo=params["cod"];
      if(this.codigo!="nuevo"){
        this.cargarActuacionAdjunto();
      }else{
        this.adjunto={};
      }
    });
  }

  ngOnInit() {
  }

  cargarActuacionAdjunto(){
    this.expedientesService.getActuacionAdjunto(this.codigo).subscribe(resp=>{
      this.adjunto=resp["adjunto"];
    });
  }

  guardarActuacionAdjunto(){
    if(this.codigo!="nuevo"){
      this.updateActuacionAdjunto();
    }else{
      this.insertActuacionAdjunto();
    }
  }
  updateActuacionAdjunto(){
    this.expedientesService.updateActuacionAdjunto(this.adjunto,this.codigo)
    .subscribe(resp=>{
      let texto=this.renderer.createText(resp["msg"]);
      this.renderer.appendChild(this.mensaje.nativeElement, texto);
      
      if(resp["err"]==false){
        this.renderer.setStyle(this.mensaje.nativeElement,"color", "green");
      }else{
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "red");
      }
      setTimeout(() => {
        this.renderer.removeChild(this.mensaje.nativeElement, texto);
      }, 1500);
    });
  }

  insertActuacionAdjunto(){
    this.adjunto["EJcodexpediente"]=this.expedientesService.expedienteActivo["EXcodigo"];
    this.adjunto["EJcodactuacion"]=this.expedientesService.actuacionActiva["EAcodigo"];
    
    this.expedientesService.insertActuacionAdjunto(this.adjunto, this.archivoSubido.nativeElement.files[0])
    .subscribe(resp=>{
      
      let texto=this.renderer.createText(resp["msg"]);
      this.renderer.appendChild(this.mensaje.nativeElement, texto);
      
      if(resp["err"]==false){
        this.renderer.setStyle(this.mensaje.nativeElement,"color", "green");
      }else{
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "red");
      }
      setTimeout(() => {
        this.renderer.removeChild(this.mensaje.nativeElement, texto);
        this.location.back();
      }, 1500);
    });
  }

  volver(){
    this.location.back();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/actuacion-adjunto/actuacion-adjunto.component.ts